export default [
  // Fonts
  {
    name: "helvetikerRegularTypeface",
    type: "font",
    path: "assets/fonts/helvetiker_regular_typeface/helvetiker_regular.typeface.json",
  },

  // Images
  {
    name: "logo",
    type: "img",
    path: "/invited_pro_logo.png",
  },

  // Textures
  {
    name: "environmentMapTexture",
    type: "cubeTexture",
    path: [
      "assets/textures/environmentMap/px.jpg",
      "assets/textures/environmentMap/nx.jpg",
      "assets/textures/environmentMap/py.jpg",
      "assets/textures/environmentMap/ny.jpg",
      "assets/textures/environmentMap/pz.jpg",
      "assets/textures/environmentMap/nz.jpg",
    ],
  },
  {
    name: "dirtColorTexture",
    type: "texture",
    path: "assets/textures/dirt/color.jpg",
  },
  {
    name: "dirtNormalTexture",
    type: "texture",
    path: "assets/textures/dirt/normal.jpg",
  },
  {
    name: "waterdudv",
    type: "texture",
    path: "/assets/images/waterdudv.jpg",
  },
  {
    name: "starParticle",
    type: "texture",
    path: "/assets/images/particle-2.png",
  },
  {
    name: "moon-w",
    type: "texture",
    path: "/assets/images/moon-w.jpg",
  },
  {
    name: "moon",
    type: "texture",
    path: "/assets/images/moon.jpg",
  },

  // Models GLTF
  // {
  //   name: "foxModel",
  //   type: "gltf",
  //   path: "assets/models/Fox/glTF/Fox.gltf",
  // },
];
